import { put } from 'redux-saga/effects';
import { InitializationActions } from '../actions/initialization';
import { PowerBiActions } from '../actions/powerBi';
import { UserActions } from '../actions/user';
import { GetUserInfoReponse } from '../../lib/api/types/GetUserInfoReponse';
import axios from 'axios';
import { getData } from './effects/getData';

export function* initializationSaga() {
    const userInfo: GetUserInfoReponse = yield getData<GetUserInfoReponse>('/Frontend/GetUserInfo');
    axios.defaults.headers.common['RequestVerificationToken'] = userInfo.aft;
    yield put(UserActions.userInfoReceived(userInfo));
    if (userInfo.isLoggedOn) {
        yield put(PowerBiActions.fetchReportDescriptions());
    }
    yield put(InitializationActions.initializationSuccess());
}
